<template>
  <div>
    <div class="my-5 text-center offset-2 col-8">
      <img src="@/assets/lock.svg" alt="" class="img-fluid" />
    </div>
    <div class="text-center">
      <h2>Jetzt anmelden</h2>
      <p>oder
        <a
            role="button"
            class="text-vue2"
            @click="changeComponent('RegisterForm')"
        >
          erstellen Sie ein Konto.
        </a>
      </p>
    </div>
    <Form @submit="submitData" :validation-schema="schema" v-slot="{errors}">
      <div class="form-body">
        <div class="form-row my-2">
          <div class="form-group col-md-8 offset-2">
            <label for="email"><strong>E-Mail-Adresse</strong></label>
            <Field as="input" type="email"
                   id="email"
                   name="email"
                   class="form-control"
                   placeholder="E-Mail Adresse"
            />
            <small class="text-danger" v-if="errors.email">
              {{ errors.email }}
            </small>
          </div>
        </div>
        <div class="form-row my-2">
          <div class="form-group col-md-8 offset-2">
            <label for="password"><strong>Password</strong></label>
            <Field as="input" type="password"
                   id="password"
                   name="password"
                   class="form-control"
                   placeholder="Password"
            />
            <small class="text-danger" v-if="errors.password">
              {{ errors.password }}
            </small>
          </div>
        </div>
        <div class="form-row mt-3">
          <div class="form-group col-md-8 offset-2">
            <div class="d-grid">
              <button class="btn bg-vue">Einloggen</button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>
<script>
import { Form, Field } from "vee-validate";
import * as yup from "yup";
export default {
  name: "LoginForm",

  components: {
    // 119;
    Form,
    Field
  },
  //121;
  emits: {
    "change-component": ( payload ) => {
      if ( payload.componentName !== "RegisterForm" ) {
        return false;
      }
      return true;
    },
  },
  // 120;
  data () {
    const schema = yup.object().shape({
      email: yup
          .string()
          .required("E-Mail Adresse ist benötigt!")
          .trim()
          .email("Das ist keine gültige E-Mail Adresse!"),
      password: yup
          .string()
          .required("Eim Password wird benötigt!")
          .min(6, "Das Password muss mindestens sechs Zeichen lang sein."),
    });
    return {
      schema,
    };
  },
  methods: {
    // 119;
    submitData( values ) {
      console.log( values );
    },
    // 121;
    changeComponent( componentName ) {
      this.$emit("change-component", { componentName });
    },
  },
};
</script>
<style scoped>

</style>